import type { PublishInfo } from '@/services/project';

export enum Stage {
  Input = 'input',
  Created = 'created',
  SandboxInfoGot = 'sandbox-info-got',
  SessionStarted = 'session-started',
  SandboxReady = 'sandbox-ready',
  Ready = 'ready',
  Error = 'error',
}

export enum ProjectStatus {
  CHAT = 'CHAT',
  PENDING = 'PENDING',
  GENERATING = 'GENERATING',
  GENERATED = 'GENERATED',
}

export type SandboxStatus = 'unknown' | 'available' | 'unavailable';

export interface ProjectDetail {
  id: string;
  userId: string;
  name: string;
  description: string | null;
  repoPath: string;
  projectPath: string;
  gitlabProjectId: string;
  status: ProjectStatus;
  createdAt: string;
  lastActiveAt?: string | null;
  updatedAt: string;
  thumbnailUrl: string | null;
  publishInfo: PublishInfo | null;
  routes?: string[] | null;
  remainingCredits?: number;
  /** 项目来源：remix-由模板创建，create-正常创建，null-旧项目 */
  websiteSource?: 'remix' | 'create' | string;
}

export interface ProjectSettings {
  REMOVE_BRAND_SWITCH: boolean;
}

export interface VersionContent {
  versionId: string;
  previewUrl: string;
  messageId: string;
  commitSha?: string;
  createdAt?: string;
  routes?: string[] | null;
  rollbackTargetId?: string | null;
};

export interface VersionHistoryRecord extends VersionContent {
  commitSha: string;
  createdAt: string;
}

export interface CodePreviewTarget {
  versionId: string;
  commitSha: string;
  createdAt: string;
}

export type ProjectPanelMode = 'preview' | 'cloud' | 'audit' | 'traffic-analytics' | 'reference' | 'launch-order' | 'code';
export type PreviewViewportMode = 'desktop' | 'mobile';

export type ProjectTaskStatus = 'pending' | 'in-progress' | 'completed';
export type ProjectTaskType = 'ai' | 'user';

export interface ProjectTaskItem {
  id: string;
  title: string;
  description: string;
  status: ProjectTaskStatus;
  type: ProjectTaskType;
  estimatedTime: string;
  createdAt: number;
  priority?: string;
}

export interface WebsiteBasicInfo {
  overview: string;
  websiteType: string;
  language: string;
  industry: string;
  targetAudience: string[];
  goals: string[];
}

export interface ProjectSummary {
  summary: string;
  websiteInfo: WebsiteBasicInfo;
  designPreferences?: string[];
  contentPreferences?: string[];
  behaviorPreferences?: string[];
  brandGuidelines?: string[];
  functionalRequirements: string[];
}
